import { Box, Grid } from '@mui/material';
import { useLocation } from 'react-router';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';

import { Header } from '@app/sections/header';
import { Strings } from '@app/constants';
import { Scrollbar } from '@app/components';
import { useTable } from '@app/components/table';
import { useDialog, useRequestState } from '@app/hooks';
import { InternDetailsListPage } from './interns-details-list-page';
import { getInternDetails, getInternTransaction } from '../slice';
import { selectInternDetailsState, selectInternTransactionState } from '../selectors';
import { AddEmployeePage } from '@app/modules/employees';
import { ProfileDetails } from '@app/modules/employees/view/profile-details';
import { BankInfo } from '@app/modules/employees/view/bank-details';
import { AssetsInfo } from '@app/modules/employees/view/assets-details';
import { LeaveInfo } from '@app/modules/employees/view/leave-details';
import { HigherEducationInfo } from '@app/modules/employees/view/higher-education-details';
import { WorkExperienceInfo } from '@app/modules/employees/view/work-experience-details';
import { EmergencyContactInfo } from '@app/modules/employees/view/emergency-contact-info';
import { OfficialInfo } from '@app/modules/employees/view/official-info';
import { ProjectsInfo } from '@app/modules/employees/view/projects-details';

const InternDetailsPage = () => {
  const { state } = useLocation();
  const tableProps = useTable();
  const editDialog = useDialog();
  const internId = state.id;
  const dispatch = useDispatch();

  useEffect(() => {
    if (internId) {
      dispatch(getInternDetails(internId));
      dispatch(getInternTransaction(internId));
    }
  }, [internId, dispatch]);

  const goBack = () => {
    history.back();
  };

  const { data } = useRequestState({
    stateSelector: selectInternDetailsState,
    errorShown: true,
  });
  const { data: internTable, loading } = useRequestState({
    stateSelector: selectInternTransactionState,
    errorShown: true,
  });
  return (
    <>
      <Box sx={{ mr: 3 }}>
        <Header
          goBack={goBack}
          title={Strings.page_title.internDetails}
          helperText={''}
          actionButtonTitle={Strings.button.editIntern}
          onClickActionButton={editDialog.show}
        />
      </Box>
      <Scrollbar>
        <Grid container>
          <Grid item xs={12}>
            <ProfileDetails userData={data} />
          </Grid>
          <Grid item xs={12} md={4}>
            <BankInfo userData={data} />
          </Grid>
          <Grid item xs={12} md={4}>
            <OfficialInfo userData={data} />
          </Grid>
          <Grid item xs={12} md={4}>
            <EmergencyContactInfo userData={data} />
          </Grid>
          <Grid item xs={12} md={4}>
            <WorkExperienceInfo userData={data} />
          </Grid>
          <Grid item xs={12} md={4}>
            <HigherEducationInfo userData={data} />
          </Grid>
          <Grid item xs={12} md={4}>
            <LeaveInfo userData={data} />
          </Grid>
          <Grid item xs={12} md={4}>
            <ProjectsInfo userData={data} />
          </Grid>
          <Grid item xs={12} md={4}>
            <AssetsInfo userData={data} />
          </Grid>
        </Grid>
        <InternDetailsListPage tableProps={tableProps} loading={loading} data={internTable} />
      </Scrollbar>
      {editDialog.visible && (
        <AddEmployeePage
          row={data}
          open={editDialog.visible}
          onClose={editDialog.hide}
          title="intern"
        />
      )}
    </>
  );
};
export { InternDetailsPage };
